import { getI18nService } from '../services/i18n';

export enum ERROR_CODE {
  '存在不可以使用的资源' = 50025,
  '分组名称不可重复' = 30024,
}

/**
 * 系统版本枚举
 */
export enum IRightsType {
  /** 未认证 */
  UN_AUTHORIZED = -1,
  /** 体验版 */
  TASTE = 1,
  /** 个人入门 */
  PERSONAL_LITE = 3,
  /** 个人标准版 */
  PERSONAL = 10,
  /** 团队体验 */
  TEAM_TASTE = 15,
  /** 团队入门 */
  TEAM_LIGHT = 16,
  /** 企业标准 */
  ORG_STANDARD = 21,
  /** 企业旗舰 */
  ORG_FLAGSHIP = 22,
  /** 企业定制（展示占位） */
  ORG_CUSTOM = 24,
}

/**
 * 收藏、空间一级分类枚举
 */
export enum COLLECTION_MAP {
  /** 作品 */
  OPUS = 0,
  /** 成片 */
  PIECES = 1,
  /** 成片模板 */
  PIECES_TEMPLATE = 2,
  /** 资源 */
  SOURCE = 3,
  /** 回收站 */
  RECYCLING_BIN = 4,
  /** 互动作品 */
  CHAT_OPUS = 6,
  /** 互动成片 */
  CHAT_PIECES = 7,
  /** 互动成片模板*/
  CHAT_PIECES_TEMPLATE = 8,
}

/**
 * 收藏来源枚举
 */
export enum COLLECTION_SOURCE {
  /** 个人空间 */
  PERSON = 0,
  /** 团队空间 */
  TEAM = 1,
  /** 与我分享 */
  SHARE = 2,
  /** 有言平台 */
  YOUYAN = 3,
  /** 最近作品 */
  RECENTLY = 4,
}

// 文件类型
export enum MEDIA_TYPE {
  /** 图片 */
  IMAGE = 0,
  /** 背景图 */
  BACKGROUND_IMAGE = 1,
  /** 音频 */
  AUDIO = 2,
  /** 视频 */
  VIDEO = 3,
  /** PAG */
  PAG = 10,
  /** PPT */
  PPT = 11,
  /** PDF */
  PDF = 12,
  /** FONT */
  FONT = 13,
  /** DOCX */
  DOCX = 14,
}

// [
//   {"text": "素材", "name": "material", "value": 0},
//   {"text": "演播室", "name": "map", "value": 2},
//   {"text": "人物", "name": "character", "value": 1},
//   {"text": "音色", "name": "tts_vcn", "value": 3},
//   {"text": "字幕模板", "name": "subtitle", "value": 4},
//   {"text": "静态文字模板", "name": "static_text_template", "value": 8},
//   {"text": "动态文字模板", "name": "dynamic_text_template", "value": 12},
//   {"text": "字体", "name": "font", "value": 6},
//   {"text": "音乐", "name": "music", "value": 7},
//   {"text": "音效", "name": "audio", "value": 11},
//   {"text": "贴纸", "name": "paster", "value": 9},
//   {"text": "片头", "name": "ae_pag_template_head", "value": 5},
//   {"text": "片尾", "name": "ae_pag_template_tail", "value": 13},
//   {"text": "模板", "name": "template", "value": 10},
//   {"text": "套装logo图", "name": "collection_logo", "value": 15},
//   {"text": "套装", "name": "collection", "value": 16},
//   {"text": "头发", "name": "hair_collection", "value": 17},
//   {"text": "妆容", "name": "makeup_collection", "value": 18},
//   {"text": "饰品", "name": "accessory", "value": 19},
//   {"text": "表情包", "name": "meme", "value": 20},
//   {'text': '主题素材', 'name': 'theme_layer', 'value': 21},
//   {"text": "sku", "name": "sku", "value": 22},
//   {"text": "PPT素材", "name": "ppt_media", "value": 23},
//   {"text": "PPT模版", "name": "ppt_template", "value": 24},
//   {"text": "角色海报", "name": "poster_template", "value": 25},
//   {"text": "素材库", "name": "media_box", "value": 26},
// ]
/**
 * 资源类型枚举
 */
export enum RESOURCE_TYPE {
  /** 素材 */
  MATERIAL = 0,
  /** 人物 */
  CHARACTER = 1,
  /** 场景/演播室 */
  MAP = 2,
  /** 音色 */
  TTS_VCN = 3,
  /** 字幕模板 */
  SUBTITLE = 4,
  /** 片头 */
  AE_PAG_TEMPLATE_HEAD = 5,
  /** 字体 */
  FONT = 6,
  /** 音乐 */
  MUSIC = 7,
  /** 静态文字模板 */
  STATIC_TEXT_TEMPLATE = 8,
  /** 贴纸 */
  PASTER = 9,
  /** 模板 */
  TEMPLATE = 10,
  /** 音效 */
  AUDIO = 11,
  /** 动态文字模板 */
  DYNAMIC_TEXT_TEMPLATE = 12,
  /** 片尾 */
  AE_PAG_TEMPLATE_TAIL = 13,
  /** 套装logo图 */
  COLLECTION_LOGO = 15,
  /** 套装 */
  COLLECTION = 16,
  /** 头发 */
  HAIR_COLLECTION = 17,
  /** 妆容 */
  MAKEUP_COLLECTION = 18,
  /** 饰品 */
  ACCESSORY = 19,
  /** 表情包 */
  MEME = 20,
  /** 主题素材 */
  THEME_LAYER = 21,
  /** sku */
  SKU = 22,
  /** PPT素材 */
  PPT_MEDIA = 23,
  /** PPT模版 */
  PPT_TEMPLATE = 24,
  /** 角色海报 */
  POSTER_TEMPLATE = 25,
  /** 素材库 */
  MEDIA_BOX = 26,
}

/** 后端model_type对应类型
 * STAR_MODEL_TYPE = DjangoChoicesConfig(
    [
        {"text": "作品", "name": "project", "value": 0},  # project_id
        {"text": "成片", "name": "task", "value": 1},  # generate_record_xihe_task_id
        {"text": "成片模板", "name": "task_template", "value": 2},  # project_id
        {"text": "资源", "name": "media", "value": 3},  # projectmedia_id/youyanconfig_id/customconfig_id
        {"text": "表演", "name": "performance", "value": 4},  # CustomerCharacterPerformance
        {"text": "表情包", "name": "meme", "value": 5},  # CustomerCharacterMeme
    ]
)
 */

/**
 * 后端model_type对应类型枚举
 */
export enum MODEL_TYPE {
  /** 作品 */
  PROJECT = 0,
  /** 成片 */
  TASK = 1,
  /** 成片模板 */
  TASK_TEMPLATE = 2,
  /** 资源 */
  MEDIA = 3,
  /** 表演 */
  PERFORMANCE = 4,
  /** 表情包 */
  MEME = 5,
  /** 互动作品 */
  CHAT_PROJECT = 6,
  /** 互动成片 */
  CHAT_TASK = 7,
  /** 互动成片模板 */
  CHAT_TASK_TEMPLATE = 8,
  /** 素材库的 PPT素材 */
  PPT_MEDIA = 9,
}

/**
 * 前端展示资源类型枚举
 */
export enum UPLOAD_TYPE {
  /** 个人空间上传 */
  PERSON,
  /** 团队空间上传 */
  TEAM,
  /** 品牌上传 */
  BRAND,
}

/**
 * 上传状态枚举
 */
export enum UPLOAD_STATUS {
  /** 成功 */
  FINISHED,
  /** 上传中 */
  UPLOADING,
  /** 上传失败 */
  ERROR,
  /** 处理中 */
  PROCESSING,
  /** 未开始上传 */
  NO_START = 10,
}

/**
 * 上传错误解决办法提示枚举
 */
export enum HINT_MAP {
  /** 没有错误 */
  DEFAULT,
  /** 升级到个人套餐 */
  UPGRADE_PERSON,
  /** 升级到团队套餐 */
  UPGRADE_TEAM,
  /** 请购买存储空间 */
  BUY_STORAGE,
  /** 请联系管理员 */
  CONTACT_THE_ADMINISTRATOR,
}

/**
 * 用户等级枚举
 */
export enum USER_ADMIN {
  /** 成员 */
  NORMAL = 1,
  /** 企业超级管理员 */
  ORG_ADMIN_USER = 2,
  /** 后台管理员 */
  MANAGEMENT_PLATFORM = 3,
  /** 超级管理员 */
  SUPER_ADMIN = 4,
}

export const MEDIA_TYPE_MAP = (): Record<number, string> => {
  const i18nService = getI18nService();
  const $t = i18nService.t;
  return {
    [MEDIA_TYPE.IMAGE]: $t('tu-pian'),
    [MEDIA_TYPE.VIDEO]: $t('shi-pin'),
    [MEDIA_TYPE.PPT]: 'PPT',
    [MEDIA_TYPE.PDF]: 'PDF',
    [MEDIA_TYPE.DOCX]: 'Word',
  };
};

/**
 * 订单行为枚举
 */
export enum ORDER_BEHAVIOR {
  /** 购买新套餐 */
  BUY = 1,
  /** 套餐升级 */
  UPGRADE = 2,
  /** 套餐续费 */
  RENEW = 3,
  /** 加购 */
  ADD_PURCHASE = 0,
}

/**
 * 订单类型枚举
 */
export enum ORDER_TYPE {
  /** 加购时长 */
  TIME = 1,
  /** 加购存储 */
  STORAGE = 2,
  /** 加购子账号 */
  ACCOUNT = 3,
  /** 加购专线 */
  RENDER = 4,
  /** 加购转授权 */
  SUBLICENSE = 5,
  /** 加购言币 */
  CREDITS = 6,
  /** 活动 */
  ACTIVITY = 7,
  /** 套餐购买 */
  PACKAGE = 99,
  /** 图生人脸 */
  PGC = 8,
}

/**
 * 水印枚举
 */
export enum WATERMARK {
  /** 无自定义水印 */
  no_watermark_with_custom = 0,
  /** 有水印 */
  has_watermark = 1,
  /** 无水印 */
  no_watermark = 2,
}

/**
 * 最大清晰度枚举
 */
export enum MAX_RESOLUTION {
  /** 1k */
  K_1 = 0,
  /** 2k */
  K_2 = 10,
  /** 4k */
  K_4 = 20,
}

/**
 * 授权范围枚举
 */
export enum RANGE {
  /** 无授权 */
  no = 0,
  /** 在线授权 */
  online = 10,
  /** 离线授权 */
  offline = 20,
  /** 全部授权 */
  all = 30,
}

/**
 * 三维场景库范围枚举
 */
export enum PROPERTY_RANGE {
  /** 全部 */
  ALL = 0,
  /** 部分 */
  PART = 1,
  /** 更多 */
  MORE = 2,
}

/**
 * 排队加速档位枚举
 */
export enum SPEED {
  /** 一档加速 */
  one_speed = 10,
  /** 二档加速 */
  two_speed = 20,
  /** 三档加速 */
  three_speed = 30,
  /** 四档加速 */
  four_speed = 40,
}

/**
 * 购买方式枚举
 */
export enum BUY_TYPE {
  /** 支付 */
  PAYMENT = 0,
  /** 订阅 */
  SUBSCRIBE = 1,
}

/**
 * 支付渠道枚举
 */
export enum PAY_TYPE {
  /** 未选择 */
  NONE = 0,
  /** 支付宝 */
  ALIPAY = 1,
  /** 微信 */
  WEIXIN = 2,
  /** 对公转账 */
  TRANSFER = 3,
  /** 免费 */
  FREE = 4,
  /** AIRWALLEX */
  AIRWALLEX = 10,
  /** STRIPE */
  STRIPE = 20,
}

/**
 * 订阅状态枚举
 */
export enum SUBSCRIBE_STATUS {
  /** 待处理 */
  PENDING = 0,
  /** 已订阅 */
  SUBSCRIBED = 1,
}

/**
 * 支付状态枚举
 */
export enum ORDER_STATUS {
  /** 未付款 */
  UNPAID = 0,
  /** 已付款 */
  PAID = 1,
  /** 交易关闭 */
  CLOSE = 2,
  /** 已退款 */
  REFUND = 3,
  /** 支付失败 */
  FAIL = 4,
  /** 已撤销 */
  REVOKE = 5,
  /** 支付中 */
  PAYING = 6,
  /** 交易结束，不可退款 */
  FINISHED = 7,
  /** 已过期 */
  EXPIRED = 99,
}

/**
 * 权益特性字段枚举
 */
export enum RIGHTS_FEATURE {
  /** 言币 */
  credit_coin = 'credit_coin',
  /** 子账号 */
  sub_account_num = 'sub_account_num',
  /** 服务线路 */
  rendering_channel_num = 'rendering_channel_num',
  /** 存储空间 */
  storage = 'storage',
}

/**
 * 项目渲染状态枚举
 */
export enum PROJECT_RENDER_STATUS {
  /** 渲染片段 */
  SEGMENT_COMPLETE = 'segment_complete',
  /** 渲染片段打断 */
  SEGMENT_INTERRUPT = 'segment_interrupt',
  /** 渲染片段失败 */
  SEGMENT_ERROR = 'segment_error',
  /** 渲染完成 */
  INIT_COMPLETE = 'init_complete',
  /** 渲染失败 */
  INIT_FAIL = 'init_error',
  /** 渲染中断 */
  INIT_INTERRUPT = 'init_interrupt',
}

/**
 * 作品渲染有视频可播放状态
 */
export const PROJECT_PLAY_STATUS = [
  PROJECT_RENDER_STATUS.SEGMENT_COMPLETE,
  PROJECT_RENDER_STATUS.SEGMENT_INTERRUPT,
  PROJECT_RENDER_STATUS.INIT_COMPLETE,
  PROJECT_RENDER_STATUS.INIT_INTERRUPT,
];

/**
 * 横竖屏枚举
 */
export enum RESOLUTION_TYPE {
  /** 横屏 */
  HORIZONTAL = '1920x1080',
  /** 竖屏 */
  VERTICAL = '1080x1920',
}

/**
 * 成片执行状态枚举
 */
export enum EXECUTION_STATUS {
  /** 未开始 */
  NOT_STARTED,
  /** 初始化 */
  DATA_INIT = 3,
  /** 等待中 */
  WAITING = 5,
  /** 处理中 */
  PROCESSING = 10,
  /** 已完成 */
  FINISHED = 20,
  /** 已取消 */
  CANCELED = 25,
  /** 错误 */
  ERROR = 99,
}

/**
 * 发票类型枚举
 */
export enum INVOICE_TYPE {
  /** 普通发票 */
  NORMAL = 0,
  /** 增值税发票 */
  VAT = 1,
}

/**
 * 开票状态枚举
 */
export enum INVOICE_STATUS {
  /** 已开票 */
  SUCCESS = 1,
  /** 开票失败 */
  FAIL = 2,
  /** 审核中 */
  WAIT = 0,
}

/**
 * 敏感视频封禁状态枚举
 */
export enum BANNED_STATUS {
  /** 未封禁 */
  NORMAL = 0,
  /** 封禁中 */
  BANNED = 1,
}

/**
 * 敏感视频申诉状态枚举
 */
export enum APPEALS_STATUS {
  /** 初始状态 */
  NORMAL = 0,
  /** 申诉中 */
  APPEALING = 1,
  /** 申诉成功 */
  APPEAL_SUCCESS = 2,
  /** 申诉失败 */
  APPEAL_FAIL = 3,
}

/**
 * 成片格式枚举
 */
export enum PIECES_VIDEO_TYPE {
  /** MP4格式 */
  MP4 = 0,
  /** MOV格式 */
  MOV = 1,
  /** WEBM格式 */
  WEBM = 2,
  /** MKV格式 */
  MKV = 3,
}

/**
 * 成片格式文本映射
 */
export const PIECES_VIDEO_TYPE_TEXT = {
  [PIECES_VIDEO_TYPE.MP4]: 'mp4',
  [PIECES_VIDEO_TYPE.MOV]: 'mov',
  [PIECES_VIDEO_TYPE.WEBM]: 'webm',
  [PIECES_VIDEO_TYPE.MKV]: 'mkv',
};

/**
 * 成片分辨率文本映射
 */
export const PIECES_VIDEO_RATE_TEXT = {
  '540x960': '540P',
  '720x1280': '720P',
  '1280x720': '720P',
  '1080x1920': '1080P',
  '1440x2560': '2K',
  '2160x3840': '4k',
  '960x540': '540P',
  '1920x1080': '1080P',
  '2560x1440': '2K',
  '3840x2160': '4k',
};

/**
 * 成片视频码率枚举
 */
export enum PIECES_VIDEO_BIT {
  /** 低码率 */
  LOW = 2,
  /** 中等码率 */
  MEDIUM = 1,
  /** 高码率 */
  HIGH = 0,
}

export enum CHECK_CARD_KEY {
  NORMAL = 'normal',
  FILM = 'film',
  TEMPLATE = 'template',
}

export enum PUBLISH_PLATFORM {
  DOUYIN = 1,
  KUAISHOU = 2,
  BLIBLI = 3,
  XHS = 4,
  YOUTUBE = 5,
  TIKTOK = 6,
  EMAIL = 7,
}

/**
 * 编辑器索引类型枚举
 */
export enum EDIT_INDEX_TYPE {
  /** 换一换 */
  CHANGE = 0,
  /** 热门推荐 */
  HOT_RECOMMEND = 1,
  /** banner位 */
  BANNER = 2,
}
/**
 * 用户认证状态枚举
 */
export enum USER_VERIFY_STATUS {
  WAIT = 0, // 待审核
  SUCCESS = 1, // 成功
  FAIL = 2, // 失败
  CANCEL = 3, // 撤销
  RESEND = 4, // 重新认证
}

// 上传错误映射
export enum UPLOAD_FAIL_REASON_MAP {
  SUCCESS = 0, // 没有错误
  INCOMPLETE = 1, // 客户端没有完成上传
  SERVER_INCOMPLETE = 2, // 服务端原因，没有完成
  RESTRICTED_SIZE = 3, // 文件大小受限
  MATERIAL_REPEAT, // 素材上传重复
  STORAGE_INSUFFICIENT, // 存储空间不足
}
// 等级类型
export enum USER_LEVEL_KEY {
  UN_AUTHORIZED = -1, // 企业未认证
  TASTE = 1, // 体验版
  PERSONAL_LITE = 3, // 个人入门
  // PERSONAL_PRO = 10, // 个人标准版
  PERSONAL = 10, // 个人标准版
  // PERSONAL_PRO = 11, // 个人pro商用
  // ORG_ORDINARY = 20, // 企业基础
  TEAM_TASTE = 15, // 团队体验
  TEAM_LIGHT = 16, // 团队入门
  ORG_STANDARD = 21, // 企业标准
  ORG_FLAGSHIP = 22, // 企业旗舰
  // ORG_CUSTOMIZE = 23, // 企业定制
}

// 作品人物类型枚举
export enum PIECES_HUMAN_TYPE {
  /** 2D人物 */
  HUMAN_2D = 2,
  /** 3D人物 */
  HUMAN_3D = 0,
  /** 卡通人物1 */
  HUMAN_CARTOON = 1,
}

export enum CHARACTER_TYPE {
  CHARACTER_3D = '3d_hyperrealism',
  CHARACTER_CARTOON = 'cartoon',
  CHARACTER_2D = '2d_hyperrealism',
}

export enum PROJECT_KIND {
  /** 普通 */
  NORMAL = 0,
  /** 互动 */
  INTERACTIVE = 1,
}

// 资产类型
export enum ASSET_TYPE {
  COMMON = 0, // 通用资产
  CUSTOM = 1, // 定制资产
  PERSONAL = 10, // 个人版
  ORG_EXPERIENCE = 15, // 团队体验版
  ORG_LIGHT = 16, // 团队入门版
  ORG_STANDARD = 21, // 企业标准版
  ORG_FLAGSHIP = 22, // 企业旗舰版
  ORG_CUSTOMIZE = 23, // 企业定制版
  PAID = 99, // 付费资产
}

// 权益升级弹窗默认tab
export enum RIGHTS_TIER_MODAL_TAB {
  CHARACTER = 'character',
  SCENE = 'scene',
  TTS_VCN = 'tts_vcn',
  FEATURE = 'feature',
}
